import type { ChartExportColumn } from 'features/charts-v2/build-chart-export-table'
import { getBreakdownById } from 'features/charts-v2/types'
import type { Breakdown } from 'features/charts-v2/types/filter-hash/v2'

/**
 * Resolves a panel's breakdowns into `ChartExportColumn`s in backend
 * category order (standard AND custom) — standard breakdowns labeled via
 * `getBreakdownById`, custom breakdowns keyed by their own `alias`. Shared by
 * every export surface that needs `buildChartExportTable`'s column contract
 * (`ChartExportButton`'s CSV export, the ask-yogi `Chart` CSV export, the
 * dashboards-2-1 PPTX appendix) so the mapping can't drift between them —
 * see `charts-v2/AGENTS.md`'s category-order trap.
 */
export const resolveExportBreakdownColumns = (
  breakdowns: Breakdown[],
): ChartExportColumn[] =>
  breakdowns.map((b) =>
    b.kind === 'standard'
      ? { id: b.id, label: getBreakdownById(b.id)?.label ?? b.id, breakdown: b }
      : { id: b.field, label: b.alias, breakdown: b },
  )
